import createReducer from 'utils/redux/createReducer'

const initialState = {
	file: undefined,
	name: undefined,
	show: false
}

export default createReducer(initialState, {
	ATTACHMENT_OPEN  : (currentState, action) => ({...currentState, href: action.data.href, file: action.data.file, name: action.data.name, show: true})
  , ATTACHMENT_CLOSE : (currentState) => ({...currentState, show: false})
})



// WEBPACK FOOTER //
// ./src/reducers/attachmentOverlay.js